// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const BigqueryIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 48 48">
    <path
      fill="url(#bigquery_svga)"
      d="m10.76 42.6-9.6-16.63a4.2 4.2 0 0 1 0-4.2l9.6-16.63a4.2 4.2 0 0 1 3.64-2.1h19.2a4.2 4.2 0 0 1 3.64 2.1l9.6 16.63a4.2 4.2 0 0 1 0 4.2l-9.6 16.63a4.2 4.2 0 0 1-3.64 2.1H14.4a4.2 4.2 0 0 1-3.64-2.1"
    />
    <path
      fill="#000"
      d="M44.2 32.1 30.07 17.97 24 16.35l-5.46 2.03-2.11 5.5 1.7 6.1L33.1 44.97l3.17-.14z"
      opacity={0.07}
    />
    <path
      fill="#fff"
      d="M24 15.39a8.48 8.48 0 1 0 0 16.96 8.48 8.48 0 0 0 0-16.96m0 14.92a6.44 6.44 0 1 1 0-12.87 6.44 6.44 0 0 1 0 12.87"
    />
    <path
      fill="#fff"
      d="M19.97 23.54v2.64q.6 1.02 1.6 1.64v-4.28zm3.17-2.22v7.1a5 5 0 0 0 1.6.01v-7.1zm3.33 3.32v3.13a5 5 0 0 0 1.6-1.72v-1.41zm3.63 4.46-.88.88a.4.4 0 0 0 0 .56l3.33 3.33a.4.4 0 0 0 .56 0l.88-.88a.4.4 0 0 0 0-.56l-3.33-3.33a.4.4 0 0 0-.56 0"
    />
    <defs>
      <linearGradient
        id="bigquery_svga"
        x1={24}
        x2={24}
        y1={3.04}
        y2={44.64}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4387FD" />
        <stop offset={1} stopColor="#4683EA" />
      </linearGradient>
    </defs>
  </svg>,
  "Bigquery",
);
export default BigqueryIcon;
